module.exports = __webpack_public_path__ + "static/media/sedano.92dc7714.svg";